var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowCircleUp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.87 33.87",
    style: {
      enableBackground: "new 0 0 33.87 33.87"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.94,0c9.35,0,16.94,7.58,16.94,16.94c0,9.35-7.58,16.94-16.94,16.94C7.58,33.87,0,26.29,0,16.94 C0,7.58,7.58,0,16.94,0z M12.94,17.84v9.67h8.3v-9.67h5.78L17.09,4.49L7.16,17.84H12.94z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowCircleUp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-circle-up.a7e4fe27.svg";
export { ForwardRef as ReactComponent };